import { Component, Input, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { Company } from 'src/app/domains/companies/models';
import { EquipmentContent } from 'src/app/domains/equipment/models';
import { EquipmentService } from 'src/app/domains/equipment/services';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-single-equipment-provisioning',
  templateUrl: './single-equipment-provisioning.component.html',
  styleUrls: ['./single-equipment-provisioning.component.scss']
})
export class SingleEquipmentProvisioningComponent implements OnInit {
  @Input() equipment: EquipmentContent;
  @Input() company: Company;
  public loading: boolean = false;
  public provisioningFile: string;
  public overrideFragment: string;
  public loadingUpdate: boolean = false;

  constructor(
    private equipmentService: EquipmentService,
    private notification: NotificationService
  ) { }

  ngOnInit() {
    this.loading = true;
    if (!this.isMessageVisible) {
      this.getProvisioningFile();
      this.getOverrideFragment();
    } else {
      this.loading = false;
    }
  }

  get isMessageVisible() {
    return(
      this.equipment.pbx === null ||
        (this.equipment.model !== 'AIR' && !this.equipment.user) ||
        (this.equipment.model === 'AIR' && this.equipment.handsets.length === 0)
    );
  }

  getProvisioningFile() {
    this.equipmentService.getProvisioningFile(this.equipment.pbx.id, this.equipment.mac_address).subscribe((res: any) => {
      this.provisioningFile = res;
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  getOverrideFragment() {
    this.equipmentService.getOverrideFragment(this.equipment.pbx.id, this.equipment.mac_address).subscribe((res: any) => {
      res ? this.overrideFragment = res : this.overrideFragment = '';
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  onUpdateOverrideFragment() {
    let blob = new Blob([this.overrideFragment], { type: 'text/plain' });
    const formData = new FormData();
    formData.append('file', blob);
    this.loadingUpdate = true;
    this.equipmentService.updateOverrideFragment(this.equipment.pbx.id, this.equipment.mac_address, formData).subscribe((res: any) => {
      this.getProvisioningFile();
      this.notification.success('equipment.details.nav-tabs.provisioning.success-updated');
      this.loadingUpdate = false;
    }, () => {
      this.loadingUpdate = false;
    });
  }

}
